import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function FilterIcon({ height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      fill="transparent"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        clipRule="evenodd"
        d="M20.595 4.591A.555.555 0 0 0 20.042 4H4.554a.554.554 0 0 0-.553.591 8.32 8.32 0 0 0 6.632 7.555v7.3a.555.555 0 0 0 .91.426l2.217-1.848a.553.553 0 0 0 .2-.426v-5.452a8.318 8.318 0 0 0 6.635-7.555z"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
